import { useLocation } from 'react-router-dom';
import { useFeatureFlagEnabled, FF } from 'modules/feature-flags';
import { useGetUserPermissions } from 'hooks/useGetUserPermissions';
import { PermissionName } from '@sironamedical/common/constants/permissionName';
import type { Permissions } from '@sironamedical/common/components/PermissionsCheck/types';
import { getPageType, PageTypes } from 'utils/pageTypes';
import { AnnouncementBanner as Banner } from './AnnouncementBanner';

const getPreferredAnnouncementPageType = (permissions: Permissions): PageTypes | null => {
  if (permissions[PermissionName.AccessWorklistModule]) return PageTypes.WORKLIST;
  if (permissions[PermissionName.AccessViewerModule]) return PageTypes.VIEWER;
  if (permissions[PermissionName.AccessReporterModule]) return PageTypes.REPORTER;
  return null;
};

export function AnnouncementBanner() {
  const [enabled] = useFeatureFlagEnabled(FF.ANNOUNCEMENT_BANNER);
  const location = useLocation();
  const permissions = useGetUserPermissions();

  const pageType = getPageType(location.pathname);
  const preferredPageType = getPreferredAnnouncementPageType(permissions);

  if (!enabled || preferredPageType == null || pageType !== preferredPageType) return null;

  return <Banner />;
}
